"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = void 0;
var styled_components_1 = require("styled-components");
var TextLoader_1 = require("../../../../components/LoadersAndProgress/TextLoader");
// import { genProfileImg } from "../../Dropdowns/utils/genProfileImg";
var genIcon_1 = require("../../Dropdowns/utils/genIcon");
var getText_1 = require("../../../../utils/getText");
var Typo2_1 = require("../../Typo2");
var themes_1 = require("../../../themes");
var genColor_1 = require("../../Dropdowns/utils/genColor");
var RadioAndCheckbox_1 = require("../../RadioAndCheckbox");
var styled_1 = require("./styled");
var grey40 = themes_1.colors.grey40, grey80 = themes_1.colors.grey80, grey60 = themes_1.colors.grey60;
var ListItem = function (_a) {
    var option = _a.option, isSelected = _a.isSelected, isFocussed = _a.isFocussed, scrollFocussedOpIntoView = _a.scrollFocussedOpIntoView, handleSelect = _a.handleSelect, setSearchString = _a.setSearchString, optionsClassName = _a.optionsClassName, S = _a.S, observerRef = _a.observerRef, isTagsStyle = _a.isTagsStyle, isMulti = _a.isMulti, value = _a.value, index = _a.index;
    var theme = (0, styled_components_1.useTheme)();
    var TypoComp = S ? Typo2_1.UI_BODY_SM_DF : Typo2_1.UI_BODY_SM_DF;
    var image = option.image, display = option.display, icon = option.icon, desc = option.desc, color = option.color, loading = option.loading, disabled = option.disabled;
    var handleClick = function () {
        if (!loading) {
            handleSelect(option);
            setSearchString && setSearchString("");
        }
    };
    if (loading) {
        return (React.createElement(styled_1.StyledListItemWrapper, { isSelected: isSelected, isFocussed: isFocussed, className: "OKE-Dropdown__option", S: S },
            React.createElement(TextLoader_1.TextLoader, { style: { width: "8rem", height: "1.5rem" } })));
    }
    var opIsSelected = function (thisOpData) {
        return value === null || value === void 0 ? void 0 : value.some(function (d) { return d.value === thisOpData.value; });
    };
    return (React.createElement(styled_1.StyledListItemWrapper, { index: index, isSelected: isSelected, isFocussed: isFocussed, className: "OKE-Dropdown__option", ref: function (el) { return isFocussed && el && scrollFocussedOpIntoView(el); }, onClick: handleClick, S: S, style: { pointerEvents: disabled && "none" } },
        React.createElement("div", { ref: observerRef, style: {
                display: "flex",
                alignItems: "flex-start",
                maxWidth: "36rem",
                gap: icon ? "0.6rem" : "0.8rem",
            } },
            (image || icon || color || isMulti) && (React.createElement("div", { style: {
                    marginTop: "0.1rem",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem"
                } },
                isMulti && !isTagsStyle ? React.createElement(RadioAndCheckbox_1.CheckboxButton, { isSelected: opIsSelected(option) }) : null,
                icon &&
                    (0, genIcon_1.genIcon)({
                        icon: icon,
                        S: S,
                        className: "OKE-Dropdown__optionIcon",
                        disabled: disabled
                    }),
                color && (0, genColor_1.genColor)({ color: color }))),
            React.createElement("div", null,
                React.createElement(TypoComp, { semibold: desc ? true : false, className: "OKE-Dropdown__optionText ".concat(optionsClassName || ""), style: { color: disabled ? grey40 : grey80 } }, (0, getText_1.getText)(display)),
                desc && (React.createElement(Typo2_1.UI_CAPTION_DF, { className: "OKE-Dropdown__optionDesc", style: { color: disabled ? grey40 : grey60, marginTop: "0.2rem" } }, (0, getText_1.getText)(desc)))))));
};
exports.ListItem = ListItem;
